// FAFI Touch T1 (FAFI-Touch-Plan §5) — should this session mount the touch layer? Pure so the
// mount matrix is unit-testable; `main.ts` passes the real probes. `?touch=1|0` forces either way
// (the house URL-knob pattern); otherwise: coarse primary pointer AND real touch points. A
// touch-screen laptop (fine primary pointer) stays desktop; the override is the dev/test door.

export interface DetectEnv {
  /** window.matchMedia, if the engine has it. */
  matchMedia?: (query: string) => { matches: boolean };
  /** navigator.maxTouchPoints. */
  maxTouchPoints?: number;
}

export function touchPreferred(params: Pick<URLSearchParams, 'get'>, env: DetectEnv): boolean {
  const forced = params.get('touch');
  if (forced === '1') return true;
  if (forced === '0') return false;
  const coarse = env.matchMedia?.('(pointer: coarse)').matches ?? false;
  return coarse && (env.maxTouchPoints ?? 0) > 0;
}

// ── D160: "make the tabs go away" ───────────────────────────────────────────
// iOS Safari has NO fullscreen API for pages — installed (Add to Home Screen) is the only chrome-free
// mode, so the layer shows a real install card instead of D159's shy toast. Pure gate, testable.

export interface InstallEnv {
  ua: string;
  maxTouchPoints?: number;
  /** Already running installed (display-mode: standalone / navigator.standalone) — never prompt. */
  standalone: boolean;
  /** The player said "don't show again" (persisted flag). */
  dismissed: boolean;
}

/** Which install card to show, if any. iPadOS masquerades as a Mac — the touch points tell it apart. */
export function installPromptMode(env: InstallEnv): 'ios' | 'android' | null {
  if (env.standalone || env.dismissed) return null;
  const ios = /iPhone|iPad|iPod/.test(env.ua) || (env.ua.includes('Mac') && (env.maxTouchPoints ?? 0) > 1);
  if (ios) return 'ios';
  if (/Android/.test(env.ua)) return 'android';
  return null;
}
